/**
 * Created by andreyna on 7/3/2016.
 */
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';
import {CashierSessionTypes} from '../../../../common/const/cashier-session-types';


const NAVIGATION_VIEWS = {
    WINDOW: 'window',
    IFRAME: 'iframe',
    REDIRECT: 'redirect',
    SECOND_WEB_VIEW: 'second_web_view'
};

const CASHIER_ACTIONS = CashierSessionTypes;

const LINK_DEFAULT_CONGIF = {
    'omg': {
        view: {
            pc: NAVIGATION_VIEWS.IFRAME,
            mobile: NAVIGATION_VIEWS.IFRAME
        },
        allowedViews: [NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-omg-frame',
        },
        isAuthRequired: true,
        isCloseBtnAllowed: false,
        immediateShow: false,
        isMobileFullScreen: false,
        priorityLevel: PRIORITY_LEVEL.OMG
    },
    'my_account': {
        view: {
          pc: NAVIGATION_VIEWS.IFRAME,
          mobile: NAVIGATION_VIEWS.IFRAME
        },
        allowedViews: [NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.IFRAME,NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-my_account-frame',
        },
        isAuthRequired: true,
        immediateShow: true
    },
    'cashier': {
        view: {
            pc: NAVIGATION_VIEWS.IFRAME,
            mobile: NAVIGATION_VIEWS.REDIRECT,
            os: {
                macos: {
                    pc: {
                        browsers: {
                            safari: {
                                view: NAVIGATION_VIEWS.WINDOW
                            }
                        }
                    }
                }
            }
        },
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-cashier-frame-full',
            sessionType: {
                '8': 'cgp-cashier-frame-full',
                '16': 'cgp-cashier-frame-deposit'
            }
        },
        isAuthRequired: true,
        immediateShow: true,
        priorityLevel: PRIORITY_LEVEL.CASHIER
    },
    'membership': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW],
        dimensions: {
            default: 'cgp-membership-frame'
        },
        isNotAuthRequired: true,
        immediateShow: true,
        priorityLevel: PRIORITY_LEVEL.MEMBERSHIP
    },
    'forgot_password': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW],
        dimensions: {
            default: 'cgp-forgot_password-frame',
        },
        isNotAuthRequired: true,
        immediateShow: true
    },
    'forgot_username': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW],
        dimensions: {
            default: 'cgp-forgot_username-frame',
        },
        isNotAuthRequired: true,
        immediateShow: true
    },
    'sport': {
        view: {
            pc: NAVIGATION_VIEWS.WINDOW,
            mobile: NAVIGATION_VIEWS.REDIRECT
        },
        allowedViews: [NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.REDIRECT, NAVIGATION_VIEWS.SECOND_WEB_VIEW],
        dimensions: {
            default: 'cgp-sport-frame',
        },
        isNotAuthRequired: false,
        immediateShow: true
    },
    'poker': {
        view: {
            pc: NAVIGATION_VIEWS.WINDOW,
            mobile: NAVIGATION_VIEWS.REDIRECT
        },
        allowedViews: [NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-poker-frame',
        },
        backToView: {
            mobile: NAVIGATION_VIEWS.REDIRECT
        },
        isNotAuthRequired: false,
        immediateShow: true
    },
    'common_link': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-external-link-url',
        },
        isNotAuthRequired: false,
        immediateShow: true
    },
    'rich': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME, NAVIGATION_VIEWS.WINDOW, NAVIGATION_VIEWS.REDIRECT],
        dimensions: {
            default: 'cgp-rich'
        },
        isAuthRequired: true,
        immediateShow: true
    },
    'pending_login': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME],
        dimensions: {
            default: 'cgp-pending-login'
        },
        isAuthRequired: false,
        immediateShow: true
    },
    'pending_play': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME],
        dimensions: {
            default: 'cgp-pending-play'
        },
        isAuthRequired: false,
        immediateShow: true
    },
    'upload_document': {
        view: NAVIGATION_VIEWS.IFRAME,
        allowedViews: [NAVIGATION_VIEWS.IFRAME],
        dimensions: {
            default: 'cgp-document-upload'
        },
        isAuthRequired: true,
        immediateShow: true,
        priorityLevel: PRIORITY_LEVEL.SECONDARY_MESSAGE
    }
};



const COMPONENT_TYPES = {
    DIRECTIVE: 'DIRECTIVE',
    API: 'API'
};

enum GNWP_SOURCES {
    CASHIER = 'cashier',
    CONTACT_US = 'contact_us',
    MEMBERSHIP = 'membership',
    FORGOT_PASSWORD = 'forgot_password',
    FORGOT_USERNAME = 'forgot_username',
    MY_ACCOUNT = 'my_account',
    OMG = 'omg',
    SPORT = 'sport',
    RICH = 'rich',
    PENDING_LOGIN = 'pending_login',
    PENDING_PLAY = 'pending_play',
    DOCUMENT_UPLOAD = 'upload_document',
    HELP = 'help'
}

export {NAVIGATION_VIEWS, LINK_DEFAULT_CONGIF, COMPONENT_TYPES, CASHIER_ACTIONS, GNWP_SOURCES};
